import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
    AUTHORIZATION_LOADING,
    AUTHORIZATION_SUCCESS,
    AUTHORIZATION_FAILED,
    ARN_AUTHORIZATION_LOADING,
    ARN_AUTHORIZATION_SUCCESS,
    ARN_AUTHORIZATION_FAILED,
    
  } from "../Constants/authorizationConstants";

export const saveAuth = (formData) => async (dispatch) => {
  try {

    dispatch({ type: AUTHORIZATION_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    formData.token = userLocalData.id;

    const requestData = formData;

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(FOLDERPATH + "/CandidateApi/saveAuthDetails", requestData, {
        headers,
     });
     
     console.log("sas",data);

     if (data.status === "success") {

    dispatch({
      type: AUTHORIZATION_SUCCESS,
      payload: data,
    });

  }else{

    // dispatch({
    //   type: AUTHORIZATION_FAILED,
    //   payload: data
    // });

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
    window.location.reload();

  }

  } catch (error) {
    dispatch({
      type: AUTHORIZATION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};

export const saveArnAuth = (formData) => async (dispatch) => {
  try {

    dispatch({ type: ARN_AUTHORIZATION_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerification'));  

    formData.token = userLocalData.id;

    const requestData = formData;

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(FOLDERPATH + "/CandidateApi/saveAuthDetails", requestData, {
        headers,
     });
     
     console.log("sas",data);

     if (data.status === "success" || data.status === "error") {

    dispatch({
      type: ARN_AUTHORIZATION_SUCCESS,
      payload: data,
    });

  }else{

    // dispatch({
    //   type: AUTHORIZATION_FAILED,
    //   payload: data
    // });

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerification"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerification", JSON.stringify(userLocalData));
    // window.location.reload();

  }

  } catch (error) {
    dispatch({
      type: ARN_AUTHORIZATION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};

export const saveManualArnAuth = (payload = {}, callBack = () => {}) => async (dispatch) => {
  try {
     const formData = new FormData();
    dispatch({ type: ARN_AUTHORIZATION_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    formData.append("token", userLocalData.id);
    formData.append("arn[0]", payload.arn)

    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + "/InstantNid/uploadCandidateARNDocument", formData, {
        headers,
     });
     
     console.log("sas",data);
     callBack(data)
     if (data.status === "success" || data.status === "error") {
    dispatch({
      type: ARN_AUTHORIZATION_SUCCESS,
      payload: data,
    });

  }else{

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerification"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerification", JSON.stringify(userLocalData));
  }

  } catch (error) {
    dispatch({
      type: ARN_AUTHORIZATION_FAILED,
      payload:
        error
    });
  }
};